import { useEffect } from "react";
import { ApplicationStore } from "../../../librettoEditor/store/ApplicationStore";

interface UseDismissPendingAddMediaFlowArgs {
    active: boolean;
    allowedSelectors?: string[];
}

const DEFAULT_ALLOWED_SELECTORS = [
    '[data-tour="editor-open-sidebar-column"]',
    '[data-tour="asset-preview-popover"]',
];

export const useDismissPendingAddMediaFlow = ({
    active,
    allowedSelectors = DEFAULT_ALLOWED_SELECTORS,
}: UseDismissPendingAddMediaFlowArgs): void => {
    useEffect(() => {
        if (!active) return;

        const selectors = allowedSelectors.filter((s) => typeof s === "string" && s.trim().length > 0);
        const handlePointerDown = (event: PointerEvent) => {
            const target = event.target as Element | null;
            if (!target) return;

            const clickedInsideAllowedArea = selectors.some((selector) => {
                try {
                    return Boolean(target.closest(selector));
                } catch {
                    return false;
                }
            });
            if (clickedInsideAllowedArea) return;

            try {
                ApplicationStore.setPendingInsertIntoScriptContext(null);
            } catch {}
        };

        window.addEventListener("pointerdown", handlePointerDown, true);
        return () => {
            window.removeEventListener("pointerdown", handlePointerDown, true);
        };
    }, [active, allowedSelectors]);
};

